import { HTTPClient } from "./client";

const PlanoAPI = {
  async Criar(plano) {
    const resposta = await HTTPClient.post("Plano", plano);
    return resposta.data;
  },

  async Obter(planoId) {
    const resposta = await HTTPClient.get(`Plano/${planoId}`);
    return resposta.data;
  },

  async Listar5() {
    const resposta = await HTTPClient.get(`Plano`);
    return resposta.data;
  },

  async Atualizar(plano) {
    const resposta = await HTTPClient.put("Plano", plano);
    return resposta.data;
  },

  async AtivarPlano(planoId) {
    const resposta = await HTTPClient.put(
      `Plano/${planoId}/ativar`,
    );
    return resposta.data;
  },

  async ListarMaterias() {
    const resposta = await HTTPClient.get("Materia");
    return resposta.data;
  },

  async AdicionarMateria(planoId, dados) {
    const resposta = await HTTPClient.post(`Plano/${planoId}/materia`, dados);
    return resposta.data;
  },

  async LancarHoras(planoMateriaId, horas) {
    const resposta = await HTTPClient.put(
      `Plano/lancar-horas?planoMateriaId=${planoMateriaId}&horas=${horas}`,
    );
    return resposta.data;
  },

  async ObterResumo() {
    const resposta = await HTTPClient.get(`Plano/gerar-resumo`);
    return resposta.data;
  },

  async CompararHoras() {
    const resposta = await HTTPClient.get(
      `Plano/horas/comparacao`,
    );
    return resposta.data;
  },
  
  async Excluir(planoId) {
    const resposta = await HTTPClient.delete(`Plano/${planoId}`);
    return resposta.data;
  },

  async ObterPlanoAtivo() {
    const resposta = await HTTPClient.get(`Plano/plano-ativo`)
    return resposta.data;
  },

  async Compartilhar(planoId) {
    const resposta = await HTTPClient.post(`Plano/${planoId}/compartilhar`);
    return resposta.data;
  },

  async Resgatar(chave) {
    const resposta = await HTTPClient.post(`Plano/resgatar`, { chave });
    return resposta.data;
  },

  async ObterGrupo(grupoId) {
    const resposta = await HTTPClient.get(`Plano/grupo/${grupoId}`);
    return resposta.data;
  }
};

export default PlanoAPI;
